import React, {useContext, useState} from 'react'
import EditOrgWithDaData from '../../../components/Modals/EditOrgWithDaData'
import OrgPage from '../../../components/OrgPage'
import LinkCell3 from '../../../components/Pages/TablePage/Table/Cells/LinkCell3/LinkCell3'
import {AuthContext} from "../../../context/AuthContext";

function All_verificationCenter() {
  const baseURL = process.env.REACT_APP_BASE_URL
  const [modalId, setModalId] = useState()
  const [editModal, showEditModal] = useState()
  const [refresh, setRefresh] = useState(false)
  const {token} = useContext(AuthContext)

  const url = `${baseURL}/api/v2/systemManagers/${token.userId}/counterParties?`

  const { REACT_APP_URL_PREFIX } = process.env

  const editOrg = (data) => {
    setModalId(data)
    showEditModal(true)
  }

  const closeHandler = () => {
    showEditModal(false)
    setRefresh(!refresh)
  }

  const linkTo = props => {
    const role = props.idArr[1]
    const id = props.idArr[0]
    const name = props.cellContent
    const verifyId = props.idArr[2]

    if (role === "Удостоверяющий центр") {
      return <LinkCell3 linkTitle={props.cellContent}
                        linkRoute={REACT_APP_URL_PREFIX + `/counterAgents/verificationCenters/${id}/${name}/medCentres/`}
                        editClick={_=>editOrg(id)} />
    }

    if (role === "Медцентр") {
      return <LinkCell3 linkTitle={props.cellContent}
                        linkRoute={REACT_APP_URL_PREFIX + `/counterAgents/medCenters/${id}/${name}/${verifyId}/organizations`}
                        editClick={_=>editOrg(id)} />
    }

    if (role === "Организация") {
      return <LinkCell3 linkTitle={props.cellContent}
                        linkRoute={REACT_APP_URL_PREFIX + `/counterAgents/organizations/${id}/${verifyId}/${name}/history`}
                        editClick={_=>editOrg(id)} />
    }
  }


  return (
    <>
      {editModal
        ? <EditOrgWithDaData id={modalId}
                             closeHandler={closeHandler}
                             Главнаяurl={'/api/v1/verificationCenter/medicalCenters?'} />
        : ''}

      <OrgPage
        refresh={refresh}
        url={url}
        haveToShow={
          [
            {
              id: 'name',
              type: 'wrapperCell',
              idArr: ['id', 'role', 'verification_id'],
              typeData: { cell: linkTo, onClick: editOrg }
            },
            { id: 'org_count' },
            { id: 'patients_count' },
            { id: 'role' },
            { id: 'invite_count' }]}
        breadCrumbsItem s={[
          { title: 'Контрагенты' },
          { title: 'Все', actual: true }
        ]}
        filterBarButtons={{
          downloadTemplate: {
            show: false,
            url: ''
          }
        }}
        filterFieldsConf={{
          name: true,
          inn: true,
          date: true,
          period: true,
          type: true
        }}
        firstRow={[
          { title: 'Название', id: 'medName' },
          { title: 'Количество организаций', id: 'calendar' },
          { title: 'Количество людей', id: '' },
          { title: 'Вид организации', id: '' },
          { title: 'Вызов', id: '' }
        ]}
      />ff
    </>
  )
}

export default All_verificationCenter
